import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import AssetDetailsModel from "./modules/AssetDetailsModel";
import moment from 'moment';
import monthSelect from '@/components/date/monthSelect';
import quarterSelect from '@/components/date/quarterSelect';
import yearSelect from '@/components/date/yearSelect';
export default {
  name: "LogDetailsList",
  mixins: [JeecgListMixin],
  components: {
    AssetDetailsModel: AssetDetailsModel,
    monthSelect: monthSelect,
    quarterSelect: quarterSelect,
    yearSelect: yearSelect
  },
  data: function data() {
    return {
      pagePath: '/ea/asset/om/log',
      pageTitle: '资产日志详细',
      autoLoadInit: false,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'productName',
        title: '产品名称',
        align: "center"
      }, {
        dataIndex: 'productCode',
        title: '产品编号',
        align: "center"
      }, {
        dataIndex: 'productCategory_dictText',
        title: '产品类型',
        align: "center"
      }, {
        dataIndex: 'productModel',
        title: '规格型号',
        align: "center"
      }, {
        dataIndex: 'consume',
        title: '运维消耗量',
        align: "center"
      }, {
        dataIndex: 'outSum',
        title: '资产出库量',
        align: "center"
      }, {
        dataIndex: 'productUnit_dictText',
        title: '单位',
        align: "center"
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      limitSelectDate: {},
      reportType: '1',
      quantum: ''
    };
  },
  props: {
    productCategory: {
      type: Number,
      default: 11
    },
    title: {
      type: String,
      default: '设备'
    }
  },
  created: function created() {
    // this.limitSelectDate = {
    //   min: moment().startOf('month'),
    //   max: moment().endOf('month')
    // }
    this.queryParam.productCategory = this.productCategory; // this.queryParam.dateStart = this.limitSelectDate.min.format("YYYY-MM-DD")
    // this.queryParam.dateEnd = this.limitSelectDate.max.format("YYYY-MM-DD")
  },
  computed: {},
  methods: {
    // onOperationDateDate: function (value, dateArray) {
    //   this.queryParam.dateStart = dateArray[0]
    //   this.queryParam.dateEnd = dateArray[1]
    // },
    initTableData: function initTableData(arg) {
      var _this = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      getAction(this.url && this.url.list ? this.url.list : this.pagePath + "/logDetails", params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
          _this.loadNums++;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this.loading = false;

        if (_this.$refs.page) {
          _this.$refs.page.disabled = false;
        }
      });
    },
    searchReset: function searchReset() {
      var that = this;
      this.queryParam = {};
      this.queryParam.productCategory = this.productCategory;
      this.queryParam.type = this.reportType;
      this.queryParam.quantum = this.quantum; // this.queryParam.dateStart = this.limitSelectDate.min.format("YYYY-MM-DD")
      // this.queryParam.dateEnd = this.limitSelectDate.max.format("YYYY-MM-DD")

      that.loadData(1);
    },
    handleDetail: function handleDetail(record) {
      this.$refs.assetDetailsModel.quantum = this.queryParam.quantum;
      this.$refs.assetDetailsModel.type = this.reportType;
      this.$refs.assetDetailsModel.show(record);
    },
    Refresh: function Refresh() {
      this.loadData();
    },
    // 月变化
    monthChange: function monthChange(value) {
      this.queryParam.quantum = value;
      this.quantum = value;
      this.queryParam.type = this.reportType;
      console.log('月变化', value);
      this.searchQuery();
    },
    // 季度变化
    quarterChange: function quarterChange(value) {
      this.queryParam.quantum = value[0] + '-' + value[1];
      this.queryParam.type = this.reportType;
      this.quantum = value[0] + '-' + value[1];
      console.log('季度变化', value); // [年,季度]
    },
    // 年变化
    yearChange: function yearChange(value) {
      this.queryParam.quantum = value;
      this.queryParam.type = this.reportType;
      this.quantum = value;
      console.log('年变化', value);
    },
    // 时间类型
    reportTypeChange: function reportTypeChange(e) {
      this.reportType = e.target.value;
    }
  }
};